import { DataGridColumnType } from '@myosh/odin-components';
import i18next from '../i18n';

export const AssignedRecordsFields = {
  id: 'id',
  moduleName: 'moduleName',
  formName: 'formName',
  docNo: 'docNo',
  description: 'description',
  status: 'status',
} as const;
export type AssignedRecordsFields = (typeof AssignedRecordsFields)[keyof typeof AssignedRecordsFields];

type ColumnEntityType = 'MODULE_NAME' | 'FORM_NAME' | 'STATUS';
interface AssignedRecordsColumnSettings {
  type?: DataGridColumnType;
  visible?: boolean;
  isIdField?: boolean;
  searchType?: string;
  dropDownValue?: string;
  dropDownText?: string;
  entityType?: ColumnEntityType;
  width?: number;
  sortField?: string;
  title: string;
}

const multiselectFilterConfig = {
  searchType: 'MultiSelect',
  dropDownValue: 'id',
  dropDownText: 'caption',
};

const textSearchFilterConfig = { type: DataGridColumnType.Number, searchType: 'TextSearch' };

export const assignedRecordsColumnsConfig: { [key in AssignedRecordsFields]?: AssignedRecordsColumnSettings } = {
  moduleName: {
    ...multiselectFilterConfig,
    entityType: 'MODULE_NAME',
    sortField: 'moduleName',
    title: i18next.t('module-name'),
  },
  formName: {
    ...multiselectFilterConfig,
    entityType: 'FORM_NAME',
    sortField: 'formName',
    title: i18next.t('form-name'),
  },
  docNo: { ...textSearchFilterConfig, sortField: 'docNo', title: i18next.t('doc-no') },
  description: { ...textSearchFilterConfig, width: 300, sortField: 'description', title: i18next.t('description') },
  status: {
    ...multiselectFilterConfig,
    entityType: 'STATUS',
    sortField: 'status',
    title: i18next.t('status'),
  },
  id: { type: DataGridColumnType.Number, visible: false, isIdField: true, title: i18next.t('id') },
};
